import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router, RouterLink } from '@angular/router';
import { Observable, of } from 'rxjs';

import { AppMainComponent, ImageDto } from '@biorec/common';
import { Doctor, Message, MessagesListType } from '@biorec/partners/domain';
import { MessagesServiceGql } from '../../messages';
import { KeycloakService } from 'keycloak-angular';
import { DoctorsServiceGql } from '../../doctors';
import { ImagesServiceGql } from '../../../../common/modules/images/images.service.gql';
import { ButtonModule } from 'primeng/button';
import { BadgeModule } from 'primeng/badge';
import { NgClass, AsyncPipe } from '@angular/common';

@Component({
	selector: 'app-topbar',
	templateUrl: './app-topbar.component.html',
	styleUrls: ['./app-topbar.component.scss'],
	providers: [ImagesServiceGql],
	standalone: true,
	imports: [RouterLink, NgClass, BadgeModule, ButtonModule, AsyncPipe],
})
export class AppTopBarComponent implements OnInit, OnDestroy {
	protected activeItem: number | null;
	public profile: Doctor;
	public image: ImageDto;

	protected $messages: Observable<Message[]>;
	private refreshTimer: NodeJS.Timeout;

	constructor(
		public appMain: AppMainComponent,
		private router: Router,
		private msgSvc: MessagesServiceGql,
		private kcs: KeycloakService,
		private docSvc: DoctorsServiceGql,
		private imgSvc: ImagesServiceGql
	) {}

	public ngOnInit() {
		this.loadData();
		this.docSvc.currentDoctor$.subscribe((profile) => {
			this.profile = profile;
			this.loadImageContent(this.profile.avatar?.id);
		});
		this.refreshTimer = setInterval(() => {
			this.loadData();
		}, 5000 * 60);
	}

	public loadImageContent(avatarId: number) {
		if (avatarId) {
			this.imgSvc
				.get(avatarId)
				.subscribe((imgDto) => (this.image = imgDto));
		}
	}

	loadData(): void {
		this.msgSvc
			.getMessagesList(MessagesListType.Personal)
			.subscribe((data) => (this.$messages = of(data)));
	}

	ngOnDestroy(): void {
		clearInterval(this.refreshTimer);
	}

	protected setSelectedMessage(id: number) {
		this.router.navigate(['/messages', id]);
	}

	protected logout(event: Event) {
		event.preventDefault();
		event.stopPropagation();
		this.kcs.logout();
	}
}
